export default __webpack_public_path__ + "static/media/20200811_205508 - 036_KRISHANU.2ad265ee.jpg";